import React from 'react';

const NotAuthorized = ({ account, ownerAddress, error, contract, boardSeats = 0 }) => {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
      <div className="text-center text-red-600">
        <h2 className="text-xl font-bold">Admin Access Required</h2>
        <p className="mt-2">You need admin privileges or governance access to view this page.</p>
        
        <div className="mt-4 p-4 bg-gray-50 rounded-md text-left">
          <h3 className="font-medium text-gray-800">Access Requirements</h3>
          <p className="text-sm mt-2">Access is granted to:</p>
          <ul className="list-disc ml-6 mt-1 text-sm text-gray-700">
            <li>The contract owner (traditional admin)</li>
            <li>Users with at least one board seat in the YILDX governance system</li>
          </ul>
        </div>
        
        <div className="mt-4 p-4 bg-gray-100 rounded-md text-left">
          <h3 className="font-medium text-gray-800">Your Status</h3>
          <p className="text-sm mt-2">Connected Account: {account}</p>
          <p className="text-sm">Contract Owner: {ownerAddress || "Not fetched"}</p>
          <p className="text-sm">Your Board Seats: {boardSeats}</p>
          <p className="text-sm">Required: At least 1 board seat (2M YILDX tokens per seat)</p>
          <p className="text-sm">Contract Loaded: {contract ? "Yes" : "No"}</p>
          {error && <p className="text-sm text-red-500 mt-2">Error: {error}</p>}
        </div>
        
        <div className="mt-4 p-4 bg-blue-50 rounded-md text-left border-l-4 border-blue-300">
          <p className="text-sm text-blue-700">
            <span className="font-medium">How to get access:</span> Acquire at least 2 million YILDX tokens to gain a board seat and governance access. Each 2M tokens grants one seat in the governance system.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotAuthorized;